const h = {
  name: "Beauty",
  dimensions: { width: 34, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 34 40" style="enable-background:new 0 0 34 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M12,0H8.6L4,4.6V13H2v8H0v19h16V21h-2v-8h-2V0z M10,13H6V5.4L9.4,2H10V13z M4,15h8v6H4V15z M2,38V23h12v15H2z
			"/>
		<path class="st0" d="M34,21h-7v-4.4h3v-2h-3v-1.6h3v-2h-3V9.3h3v-2h-3V5.6h3v-2h-3V2h3V0h-8v2h3v1.6h-3v2h3v1.6h-3v2h3v1.6h-3v2h3
			v1.6h-3v2h3V21h-7v11c0,4.4,3.6,8,8,8s8-3.6,8-8V21z M20,32v-9h12v9c0,3.3-2.7,6-6,6S20,35.3,20,32z"/>
	</g>
</g>
</svg>
  `
};
export {
  h as Beauty
};
